module.exports = __webpack_public_path__ + "web_static/img/blue_exclaimation_gif.93f0b3ce.gif";